import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import minimiseCableImage from "../../../assets/smartbuilding/installation/installation-minimiseCable.png";
import noInternetImage from "../../../assets/smartbuilding/installation/installation-programmation.png";
import preProgramImage from "../../../assets/smartbuilding/installation/installation-surTable.png";

const features = [
  {
    name: "preProgram",
    image: preProgramImage,
  },
  {
    name: "minimiseCable",
    image: minimiseCableImage,
  },
  {
    name: "noInternet",
    image: noInternetImage,
  },
];

export default function HeatingSection(props) {
  const { textContent, language } = { ...props };
  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      <div className="container-small">
        <h1 className="title-gradient">
          {textContent.installationSection.title[language]}
        </h1>
      </div>
      <div className="container-empty-small" />
      <div className={`grid-3 installation-sb ${isMobile ? "carousel" : ""}`}>
        {features.map((feature, index) => (
          <div className="installation-card-sb" key={index}>
            <div className="installationImage">
              <img src={feature.image} alt="" />
            </div>
            <div className="installationText">
              <h3 className="h3-bold">
                {
                  textContent.installationSection.features?.items[feature.name]
                    ?.title[language]
                }
              </h3>

              <p>
                {
                  textContent.installationSection.features?.items[feature.name]
                    ?.description[language]
                }
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
